'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _themeProductForm = require('@shopify/theme-product-form');

var _themeCurrency = require('@shopify/theme-currency');

var _themeSections = require('@shopify/theme-sections');

var _themeA11y = require('@shopify/theme-a11y');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

var classes = {
    hide: 'hide'
};

var keyboardKeys = {
    ENTER: 13
};

var selectors = {
    submitButton: '[data-submit-button]',
    submitButtonText: '[data-submit-button-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    priceWrapper: '[data-price-wrapper]',
    imageWrapper: '[data-product-image-wrapper]',
    visibleImageWrapper: '[data-product-image-wrapper]:not(.' + classes.hide + ')',
    imageWrapperById: function imageWrapperById(id) {
        return selectors.imageWrapper + '[data-image-id=\'' + id + '\']';
    },
    productForm: '[data-product-form]',
    productPrice: '[data-product-price]',
    thumbnail: '[data-product-single-thumbnail]',
    thumbnailById: function thumbnailById(id) {
        return '[data-thumbnail-id=\'' + id + '\']';
    },
    thumbnailActive: '[data-product-single-thumbnail][aria-current]'
};

(0, _themeSections.register)('product', {
    onLoad: function onLoad() {
        var _this = this;

        return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var productFormElement, variants, main_obj, $window, thumbs_slider;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            productFormElement = document.querySelector(selectors.productForm);

                            //        this.product = await this.getProductJson(
                            //            productFormElement.dataset.productHandle,
                            //            );

                            _this.product = JSON.parse(document.getElementById('ProductJson').innerHTML);
                            //console.info(this.product);
                            _this.productForm = new _themeProductForm.ProductForm(productFormElement, _this.product, {
                                onOptionChange: _this.onFormOptionChange.bind(_this)
                            });
                            variants = _this.product.variants;
                            main_obj = _this;
                            $window = $(window);


                            if ($window.width() > 768) {
                                $('.page-product__images-item').zoom();
                            }

                            $('.page-product__images-items').slick({
                                fade: true,
                                arrows: false,
                                asNavFor: '.page-product__images-thumbs'
                            });
                            thumbs_slider = $('.page-product__images-thumbs');

                            thumbs_slider.slick({
                                //fade: true,
                                arrows: true,
                                slidesToShow: 4,

                                asNavFor: '.page-product__images-items',
                                focusOnSelect: true,
                                mobileFirst: true,
                                vertical: false,
                                infinite: true,
                                //variableWidth: true,
                                responsive: [{
                                    breakpoint: 768,
                                    settings: {
                                        variableWidth: false,
                                        vertical: true,
                                        slidesToShow: 4
                                    }
                                }]
                                //centerMode: true
                            });

                            //        thumbs_slider.on( 'wheel', ( function ( e ) {
                            //            e.preventDefault();
                            //
                            //            if ( e.originalEvent.deltaY < 0 ) {
                            //                $( this ).slick( 'slickNext' );
                            //            } else {
                            //                $( this ).slick( 'slickPrev' );
                            //            }
                            //        } ) );
                            $('.page-product__more-info-details').on('click', function () {
                                var $product_description = $('.page-product__main');
                                var next_section = $product_description.next();
                                var next_section_offset = next_section.offset();
                                $("html, body").animate({ scrollTop: next_section_offset.top - $('.site-header').innerHeight() + 1 }, "slow");
                                return false;
                            });
                            $('.page-product__more-info a').fancybox();

                            $.fn.init_quantity = function () {
                                $(this).each(function () {
                                    var $quantity = $(this);
                                    var $minus = $quantity.find('.minus');
                                    var $input = $quantity.find('input');
                                    var $plus = $quantity.find('.plus');

                                    $minus.on('click', function () {
                                        var current_val = parseInt($input.val());
                                        if (current_val >= 2) {
                                            $input.val(current_val - 1);
                                        }
                                    });
                                    $plus.on('click', function () {
                                        var current_val = parseInt($input.val());
                                        $input.val(current_val + 1);
                                    });
                                });
                            };
                            $('.page-product__quantity-input').init_quantity();

                            jQuery('.swatch :radio').change(function () {

                                var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                                var optionValue = jQuery(this).val();
                                var jSelector = jQuery(this).closest('form').find('.single-option-selector').eq(optionIndex);
                                jSelector.val(optionValue);
                                //.trigger( 'change' );
                                var selector = document.querySelector('#' + jSelector.prop('id'));
                                selector.dispatchEvent(new Event("change"));

                                //            var index = jQuery( '.swatch :radio' ).index( this );
                                //            console.log(index);
                                //            console.info(variants);
                                //            var variant_obj = variants[index];
                                //console.log(variant_obj);
                                //            main_obj.renderImages( variant_obj );
                                //            main_obj.renderPrice( variant_obj );
                                //            main_obj.renderComparePrice( variant_obj );
                                //            main_obj.renderSubmitButton( variant_obj );
                                //            main_obj.updateBrowserHistory( variant_obj );
                            }); //;

                            jQuery('.swatch').each(function () {
                                jQuery(this).find(' :radio').filter(':first').trigger('change');
                            });

                            jQuery('.page-product__add-to-cart').on('click', function (event) {
                                event.preventDefault();

                                //console.log('tuta');
                                $.ajax({
                                    type: 'POST',
                                    url: '/cart/add.js',
                                    dataType: 'json',
                                    data: $('.shopify-product-form').serialize(),
                                    success: function success() {
                                        $.ajax({
                                            type: 'GET',
                                            url: '/cart/?view=minicart',
                                            success: function success(result) {
                                                $('.minicart__wrapper').html(result);
                                                $('body').addClass('minicart-open');
                                                $('.site-header__cart').addClass('has-items');
                                            },
                                            error: function error() {}
                                        });
                                    },
                                    error: function error() {}
                                });
                            });

                            $('.sticky-add-to-cart__cta a').on('click', function (event) {
                                event.preventDefault();
                                jQuery('.page-product__add-to-cart').trigger('click');
                            });

                            Shopify.Products.recordRecentlyViewed();

                            Shopify.Products.showRecentlyViewed({
                                howManyToShow: 4,
                                wrapperId: 'recently-viewed-products__items',
                                onComplete: function onComplete() {
                                    $('#recently-viewed-products__items').slick({
                                        arrows: true,
                                        slidesToShow: 1,
                                        mobileFirst: true,

                                        responsive: [{
                                            breakpoint: 768,
                                            settings: {
                                                slidesToShow: 3
                                            }
                                        }]
                                    });
                                    $('.recently-viewed-products').show();
                                }
                            });

                            $.fn.init_sticky_add_to_cart = function () {
                                var $fn = $(this);
                                var $window = $(window);

                                var setup_fixed = function setup_fixed() {
                                    var $product_description = $('.page-product__main');
                                    var $product_description_offset = $product_description.offset();
                                    var $footer_offset = $('.site-footer').offset();

                                    //                console.clear();
                                    //                console.log($window.scrollTop());
                                    //console.info('footer: '+$footer_offset.top);
                                    //console.log($window.height());

                                    if ($window.scrollTop() > $product_description.innerHeight() + $product_description_offset.top - $('.site-header').innerHeight() && $window.scrollTop() < $footer_offset.top - $window.height()) {
                                        //                    console.log($product_description.innerHeight());
                                        //                    console.log($product_description_offset.top);
                                        $fn.fadeIn();
                                    } else {
                                        $fn.fadeOut();
                                    }
                                };
                                $window.scroll(function (e) {
                                    setup_fixed();
                                });
                                setup_fixed();
                            };

                            $('.sticky-add-to-cart').init_sticky_add_to_cart();

                        case 22:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    onUnload: function onUnload() {
        this.productForm.destroy();
    },
    getProductJson: function getProductJson(handle) {
        return fetch('/products/' + handle + '.js').then(function (response) {
            return response.json();
        });
    },
    onFormOptionChange: function onFormOptionChange(event) {
        var variant = event.dataset.variant;

        jQuery('.page-product__variants').val(variant.id);

        this.renderImages(variant);
        this.renderPrice(variant);
        this.renderSku(variant);
        this.renderComparePrice(variant);
        this.renderSubmitButton(variant);

        //this.updateBrowserHistory( variant );
    },
    renderSubmitButton: function renderSubmitButton(variant) {
        var submitButton = this.container.querySelector(selectors.submitButton);
        var submitButtonText = this.container.querySelector(selectors.submitButtonText);

        if (!variant) {
            submitButton.disabled = true;
            submitButtonText.innerText = theme.strings.unavailable;
        } else if (variant.available) {
            submitButton.disabled = false;
            submitButtonText.innerText = 'Add to bag';
        } else {
            submitButton.disabled = true;
            submitButtonText.innerText = theme.strings.soldOut;
        }
    },
    renderImages: function renderImages(variant) {
        if (!variant || variant.featured_image === null) {
            return;
        }

        this.renderFeaturedImage(variant.featured_image.id);
        this.renderActiveThumbnail(variant.featured_image.id);
    },
    renderPrice: function renderPrice(variant) {
        var priceElement = this.container.querySelector(selectors.productPrice);
        var priceWrapperElement = this.container.querySelector(selectors.priceWrapper);

        priceWrapperElement.classList.toggle(classes.hide, !variant);

        if (variant) {
            priceElement.innerText = (0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat);
            $('.sticky-add-to-cart__price').text((0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat));
        }
    },
    renderSku: function renderSku(variant) {

        if (variant) {
            $('.page-product__sku span').text(variant.sku);
        }
    },
    renderComparePrice: function renderComparePrice(variant) {
        if (!variant) {
            return;
        }

        var comparePriceElement = this.container.querySelector(selectors.comparePrice);
        var compareTextElement = this.container.querySelector(selectors.comparePriceText);

        if (!comparePriceElement || !compareTextElement) {
            return;
        }

        if (variant.compare_at_price > variant.price) {
            comparePriceElement.innerText = (0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat);
            compareTextElement.classList.remove(classes.hide);
            comparePriceElement.classList.remove(classes.hide);
        } else {
            comparePriceElement.innerText = '';
            compareTextElement.classList.add(classes.hide);
            comparePriceElement.classList.add(classes.hide);
        }
    },
    renderActiveThumbnail: function renderActiveThumbnail(id) {
        //        const activeThumbnail = this.container.querySelector(
        //            selectors.thumbnailById( id ),
        //            );
        //        const inactiveThumbnail = this.container.querySelector(
        //            selectors.thumbnailActive,
        //            );
        //
        //        if ( activeThumbnail === inactiveThumbnail ) {
        //            return;
        //        }
        //
        //        inactiveThumbnail.removeAttribute( 'aria-current' );
        //        activeThumbnail.setAttribute( 'aria-current', true );
    },
    renderFeaturedImage: function renderFeaturedImage(id) {
        //        const activeImage = this.container.querySelector(
        //            selectors.visibleImageWrapper,
        //            );
        //        const inactiveImage = this.container.querySelector(
        //            selectors.imageWrapperById( id ),
        //            );
        //
        //        activeImage.classList.add( classes.hide );
        //        inactiveImage.classList.remove( classes.hide );

        //$( '.page-product__images-items' ).slick('slickGoTo', $('[data-id="'+id+'"]').data('slick-index'));
        $('[data-id="' + id + '"]').trigger('click');
    },
    updateBrowserHistory: function updateBrowserHistory(variant) {
        var enableHistoryState = this.productForm.element.dataset.enableHistoryState;

        if (!variant || enableHistoryState !== 'true') {
            return;
        }

        var url = (0, _themeProductForm.getUrlWithVariant)(window.location.href, variant.id);
        window.history.replaceState({ path: url }, '', url);
    }
});